export enum ConstructionEndDateType {
    READY = 0,
    THREE_MONTHS = 3,
    SIX_MONTHS = 6,
    YEAR = 12,
    TWO_YEARS = 24,
    THREE_YEARS = 36
}
export enum ConstructionEndDateType {
    READY = 0,
    THREE_MONTHS = 3,
    SIX_MONTHS = 6,
    YEAR = 12,
    TWO_YEARS = 24,
    THREE_YEARS = 36
}
